'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');
var MaskedInput = require('react-text-mask');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var MaskedInput__default = /*#__PURE__*/_interopDefaultLegacy(MaskedInput);

//internal component
var PhoneInputStyle = styled__default["default"](MaskedInput__default["default"])(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  cursor: text;\n\n  ::placeholder {\n    color: ", ";\n  }\n"], ["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  cursor: text;\n\n  ::placeholder {\n    color: ", ";\n  }\n"])), function (_a) {
    var primary = _a.theme.fonts.primary;
    return primary;
}, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
}, function (_a) {
    var fontSize = _a.theme.typography.body2.fontSize;
    return fontSize;
}, function (_a) {
    var fontWeight = _a.theme.typography.body2.fontWeight;
    return fontWeight;
}, function (_a) {
    var lineHeight = _a.theme.typography.body2.lineHeight;
    return lineHeight;
}, function (_a) {
    var letterSpacing = _a.theme.typography.body2.letterSpacing;
    return letterSpacing;
}, function (_a) {
    var secondary = _a.theme.colors.text.secondary;
    return secondary;
});
var PhoneInput = React__default["default"].forwardRef(function (props, _ref) { return (React__default["default"].createElement(PhoneInputStyle, tslib_es6.__assign({}, props, { mask: [
        '(',
        /[1-9]/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
    ], placeholderChar: '\u2000', showMask: true, guide: false }))); });
var templateObject_1;

exports["default"] = PhoneInput;
